import { FC, useState } from "react";
import { styled } from "styled-components";
import { Container } from "../containers/PageContainer";
import { useMenu } from "../hooks/useMenu";
import { useScroll } from "../hooks/useScroll";

import IMG1 from "../assets/foto/1.jpg";
import IMG10 from "../assets/foto/10.jpg";
import IMG11 from "../assets/foto/11.jpg";
import IMG12 from "../assets/foto/12.jpg";
import IMG13 from "../assets/foto/13.jpg";
import IMG14 from "../assets/foto/14.jpg";
import IMG15 from "../assets/foto/15.jpg";
import IMG16 from "../assets/foto/16.jpg";
import IMG17 from "../assets/foto/17.jpg";
import IMG18 from "../assets/foto/18.jpg";
import IMG19 from "../assets/foto/19.jpg";
import IMG2 from "../assets/foto/2.jpg";
import IMG20 from "../assets/foto/20.jpg";
import IMG21 from "../assets/foto/21.jpg";
import IMG22 from "../assets/foto/22.jpg";
import IMG23 from "../assets/foto/23.jpg";
import IMG24 from "../assets/foto/24.jpg";
import IMG25 from "../assets/foto/25.jpg";
import IMG3 from "../assets/foto/3.jpg";
import IMG4 from "../assets/foto/4.jpg";
import IMG5 from "../assets/foto/5.jpg";
import IMG6 from "../assets/foto/6.jpg";
import IMG7 from "../assets/foto/7.jpg";
import IMG8 from "../assets/foto/8.jpg";
import IMG9 from "../assets/foto/9.jpg";
import { StyledH1 } from "../StyledComponents";

const photos1 = [
  { src: IMG1, alt: "Photo 1" },
  { src: IMG2, alt: "Photo 2" },
  { src: IMG3, alt: "Photo 3" },
  { src: IMG4, alt: "Photo 4" },
  { src: IMG5, alt: "Photo 5" },
  { src: IMG6, alt: "Photo 6" },
  { src: IMG7, alt: "Photo 7" },
  { src: IMG8, alt: "Photo 8" },
  { src: IMG9, alt: "Photo 9" },
  { src: IMG10, alt: "Photo 10" },
  { src: IMG11, alt: "Photo 11" },
];

const photos2 = [
  { src: IMG12, alt: "Photo 12" },
  { src: IMG13, alt: "Photo 13" },
  { src: IMG14, alt: "Photo 14" },
  { src: IMG15, alt: "Photo 15" },
  { src: IMG16, alt: "Photo 16" },
  { src: IMG17, alt: "Photo 17" },
  { src: IMG18, alt: "Photo 18" },
  { src: IMG19, alt: "Photo 19" },
  { src: IMG20, alt: "Photo 20" },
  { src: IMG21, alt: "Photo 21" },
  { src: IMG22, alt: "Photo 22" },
  { src: IMG23, alt: "Photo 23" },
  { src: IMG24, alt: "Photo 24" },
  { src: IMG25, alt: "Photo 25" },
];

const Photogalery: FC = () => {
  const { isScrolled } = useScroll();
  const { isMenuClosed } = useMenu();

  const [isModalOpen, setModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState("");

  const handleThumbnailClick = (imageSrc: string) => {
    setCurrentImage(imageSrc);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };
  return (
    <Container $isScrolled={isScrolled} $isMenuClosed={isMenuClosed}>
      <StyledH1>Fotogalerie</StyledH1>
      <PhotoPageContainer>
        {/* <SeclectMenuContainer>filter menu</SeclectMenuContainer> */}
        <PhotoContainer>
          <PhotoColumnContainer>
            {photos1.map((photo, index) => (
              <PhotoItem key={index}>
                <Thumbnail
                  src={photo.src}
                  alt={photo.alt}
                  onClick={() => handleThumbnailClick(photo.src)}
                />
              </PhotoItem>
            ))}
          </PhotoColumnContainer>
          <PhotoColumnContainer>
            {photos2.map((photo, index) => (
              <PhotoItem key={index}>
                <Thumbnail
                  src={photo.src}
                  alt={photo.alt}
                  onClick={() => handleThumbnailClick(photo.src)}
                />
              </PhotoItem>
            ))}
          </PhotoColumnContainer>
        </PhotoContainer>
      </PhotoPageContainer>
      <Modal $isOpen={isModalOpen} onClick={handleCloseModal}>
        <CloseButton onClick={handleCloseModal}>&times;</CloseButton>
        <ModalContent src={currentImage} alt="Full Image" />
      </Modal>
    </Container>
  );
};

export default Photogalery;

const PhotoPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
  padding: 20px;
  max-width: 1300px;
  @media (max-width: 768px) {
    flex-direction: row-reverse;
    align-items: self-start;
  }
`;

const SeclectMenuContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    margin-left: 20px;
  }
`;

const PhotoContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  gap: 16px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const PhotoColumnContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 16px;
  width: 48%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;
const PhotoItem = styled.div`
  display: flex;
  background-color: #f1ebdd;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(215, 242, 128, 0.1);
`;

const Thumbnail = styled.img`
  width: 100%;
  cursor: pointer;
  &:hover {
    border-radius: 8px;
    transform: scale(1.07); /* Mírné zvětšení obrázku */
    filter: brightness(0.8); /* Ztmavení obrázku */
  }
`;

const Modal = styled.div<{ $isOpen: boolean }>`
  display: ${({ $isOpen }) => ($isOpen ? "flex" : "none")};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  justify-content: center;
  align-items: center;
  z-index: 1001;
`;

const ModalContent = styled.img`
  max-width: 90%;
  max-height: 90%;
`;

const CloseButton = styled.span`
  position: absolute;
  top: 20px;
  right: 30px;
  color: white;
  font-size: 30px;
  cursor: pointer;
`;
